import type { WindTypes } from "@/util/Tailwind";
import type React from "react";
import { twMerge } from "tailwind-merge";

const Wrapper = ({className, children, onClick}: React.PropsWithChildren<{
    className?: string,
    onClick?: React.MouseEventHandler<HTMLDivElement>;
}>) =>
{
    if (!className) return children;

    return (
        <div
            className={className}
            onClick={onClick}
        >
            {children}
        </div>
    );
};

const Padding = ({
    top,
    bottom,
    children,
    mask,
    themeMask,
    className,
    backgroundColor,
    background,
    style,
    shouldTranslateKeyboard,
    wrapper,
    onClick,
}: React.PropsWithChildren<{
    wrapper?: string;
    top?: boolean;
    bottom?: boolean;
    mask?: WindTypes["backgroundColor"];
    themeMask?: string;
    backgroundColor?: WindTypes["backgroundColor"];
    background?: CSSStyleDeclaration["background"];
    className?: string;
    style?: React.CSSProperties;
    shouldTranslateKeyboard?: boolean;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
}>) =>
{
    const safeTop = "var(--safe-area-top)";
    const safeTopKeyboard = "calc(var(--safe-area-top) + var(--safe-area-keyboard))";
    const safeBottom = "var(--safe-area-bottom)";
    const safeKeyboard = "calc(-1 * var(--safe-area-keyboard))";

    const topMargin = top? (shouldTranslateKeyboard? safeTopKeyboard: safeTop): "0px";
    const bottomMargin = bottom? (shouldTranslateKeyboard? safeKeyboard: safeBottom): "0px";
    const translate = shouldTranslateKeyboard? `0px ${safeKeyboard}`: "none";

    const width = "100%";
    const position = "absolute";

    return (
        <Wrapper
            className={wrapper}
            onClick={onClick}
        >
            {backgroundColor && !background && (
                <div
                    style={{
                        width,
                        position,
                        top: "0px",
                        bottom: "0px",
                        translate
                    }}
                    className={Wind.style({
                        backgroundColor: backgroundColor,
                    }).class}
                />
            )}
            {background && !backgroundColor && (
                <div
                    style={{
                        width,
                        position,
                        top: "0px",
                        bottom: "0px",
                        background,
                        translate
                    }}
                />
            )}
            {(mask !== undefined || themeMask !== undefined) && (
                <div
                    className={mask}
                    style={{
                        width,
                        position,
                        top: "0px",
                        bottom: `calc(100% - ${topMargin})`,
                        backgroundColor: themeMask,
                        zIndex: 1,
                        translate
                    }}
                />
            )}
            <div
                className={twMerge("padding-wrapper", className)}
                style={{
                    width,
                    position,
                    top: topMargin,
                    bottom: bottomMargin,
                    translate,
                    ...style
                }}

            >
                {children}
            </div>
            {(mask !== undefined || themeMask !== undefined) && (
                <div
                    className={mask}
                    style={{
                        width,
                        position,
                        top: `calc(100% - ${bottomMargin} - 0.063rem)`,
                        bottom: 0,
                        backgroundColor: themeMask,
                        zIndex: 1,
                        translate,
                    }}
                />
            )}
        </Wrapper>
    );
};

export default Padding;
